import { Action } from "./cockpit-action";
import { ResourceType } from "./cockpit-ressource-type";

export class MakeOperationRequest {
  resourceId: number | null = 0;
  resourceType: ResourceType | null = null;
  action: Action | null = null;

  constructor(init?: Partial<MakeOperationRequest>) {
    Object.assign(this, init);
  }
}
